export { HtmlStorageLocation } from "@bitwarden/storage-core";
